import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import { useFormikContext } from 'formik'
import _, { isEmpty } from 'lodash'
import React from 'react'

import { apiEndpoints } from 'api'
import { AutoComplete } from 'app/components/generic/FormElements'
import { makeRequestUrl } from 'app/helpers'
import { validateNotEmpty } from 'app/validators'

// Programs no longer sold. Their rows stay in the backend so existing
// enrolments keep resolving, but they can't be picked for a new booking.
const DISCONTINUED_PROGRAM_NAMES = ['Toddler Club 1 month']

const ProgramSelectionForm = (props) => {
  const { formData } = props
  const { errors, setFieldValue } = useFormikContext()
  return (
    <>
      <FormControl
        variant="outlined"
        {...(!isEmpty(errors.program) ? { error: true } : null)}
        required
      >
        <AutoComplete
          name={'program'}
          placeholder="Select program"
          minCharactersToSearch={0}
          getStructuredValues={(data) => {
            const getItemStructure = (item) => {
              return item
                ? {
                    uuid: item,
                    name: item.name
                  }
                : null
            }

            const isSellable = (item) =>
              !DISCONTINUED_PROGRAM_NAMES.includes(item?.name)

            if (Array.isArray(data)) {
              return data?.filter(isSellable).map((item) => {
                return getItemStructure(item)
              })
            } else if (Object.prototype.hasOwnProperty.call(data, 'results')) {
              return data?.results?.filter(isSellable).map((item) => {
                return getItemStructure(item)
              })
            }

            return [getItemStructure(data)]
          }}
          getFormDataValue={(data) => {
            const getItemStructure = (item) => {
              return item.uuid
            }
            return getItemStructure(data)
          }}
          getOptionLabelKey="name"
          getOptionSelectedKey="uuid"
          resultStructure={{
            keyName: 'program',
            keyValue: 'uuid'
          }}
          apiOptions={{
            method: 'get',
            url: makeRequestUrl(`${apiEndpoints.programs}/programs`, {
              exclude: 'school,care,excel,exploration_camp'
            })
          }}
          required={true}
          setFieldValue={setFieldValue}
          formData={formData}
          validate={validateNotEmpty({ isRequired: true })}
        />
        {!isEmpty(errors.program) && (
          <FormHelperText>{errors.program}</FormHelperText>
        )}
      </FormControl>
    </>
  )
}

export default ProgramSelectionForm
